// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3PPIT","search":"Settings_search__3a5cN","filter":"Settings_filter__1vH5d"};